module.exports = __webpack_public_path__ + "img/appSettings.990bfc6f.png";